import { configureStore } from '@reduxjs/toolkit';
import tarotReducer from './slices/tarotSlice';
import journalReducer from './slices/journalSlice';


export const store = configureStore({
  reducer: {
    tarot: tarotReducer,
    journal: journalReducer,
  },
});
